import { ApiRequest } from "src/models/api.request";
import HbsHastaMuayeneDTO from "src/models/HastaServis/VwHbsHastaMuayeneDTO";
import HbsHastaMuayeneSablonDTO from "src/models/HastaServis/HbsHastaMuayeneSablonDTO";
import VwHbsHastarecete1DTO from "src/models/HastaServis/VwHbsHastarecete1DTO ";
import VwHbsHastarecete2DTO from "src/models/HastaServis/VwHbsHastarecete2DTO";
import VwHbsHastarecetelistDTO from "src/models/HastaServis/VwHbsHastarecetelistDTO";
import api from "src/services/core/api";
import { RootState } from "src/store";

const controllerName = "VwHbsHastaMuayeneDTO";

export const HastaMuayeneApi = api.injectEndpoints({
    endpoints: builder => ({
        getHastaMuayene: builder.query<Array<HbsHastaMuayeneDTO>, { servisId: number, muracaatId: number, tip?: number }>({
            query: (request) => {
                let apiRequest: ApiRequest<HbsHastaMuayeneDTO> = {
                    filters: {
                        groupOperator: "and",
                        predicates: [
                            { fieldName: "hastaservisId", operator: "=", value1: request.servisId },
                            { fieldName: "muracaatId", operator: "=", value1: request.muracaatId }
                        ]
                    },
                    sorts: [
                        { fieldName: "sira", ascending: false }
                    ]
                };
                if (request.tip > 0) {
                    apiRequest.filters.predicates.push({
                        fieldName: "raporId",
                        operator: "=",
                        value1: 4
                    });
                }
                return {
                    url: controllerName + "/find",
                    method: "POST",
                    body: JSON.stringify(apiRequest)
                }
            },
            providesTags: ["HastaMuayene"]
        }),
        addHastaMuayene: builder.mutation<HbsHastaMuayeneDTO, HbsHastaMuayeneDTO>({
            query: (request) => ({
                url: "HastaServis/HastaMuayeneAnamnezEkle",
                method: "POST",
                body: JSON.stringify(request)
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                const { data } = await queryFulfilled;
                dispatch(
                    HastaMuayeneApi.util.updateQueryData(
                        "getHastaMuayene",
                        { servisId: arg.hastaservisId, muracaatId: arg.muracaatId },
                        (draft) => {
                            draft.unshift(data);
                        }
                    )
                );
            },
        }),
        updateHastaMuayene: builder.mutation<HbsHastaMuayeneDTO, HbsHastaMuayeneDTO>({
            query: (request) => ({
                url: "HastaServis/HastaMuayeneAnamnezGuncelle",
                method: "PUT",
                body: JSON.stringify(request)
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch, getState }) {
                const { data } = await queryFulfilled;
                dispatch(
                    HastaMuayeneApi.util.updateQueryData(
                        "getHastaMuayene",
                        { servisId: arg.hastaservisId, muracaatId: arg.muracaatId },
                        (draft) => {
                            return draft.map((m) =>
                                m.id === data.id
                                    ? arg
                                    : m
                            );
                        })
                );
            },
        }),
        deleteHastaMuayene: builder.mutation<boolean, number>({
            query: (id) => ({
                url: controllerName + "/" + id,
                method: "DELETE"
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch, getState }) {
                await queryFulfilled;
                dispatch(
                    HastaMuayeneApi.util.updateQueryData(
                        "getHastaMuayene",
                        { servisId: (getState() as RootState).hastaServis.activeRow.id, muracaatId: (getState() as RootState).hastaServis.activeRow.muracaatId },
                        (draft) => {
                            return draft.filter((m) => m.id !== arg);
                        })
                );
            },
        }),
        hastaMuayeneSablonGetir: builder.query<Array<HbsHastaMuayeneSablonDTO>, {
            servisveriId: number,
            bransId: number
        }>({
            query: (request) => ({
                url: "hastaservis/HastaMuayeneSablonGetir/" + request.servisveriId + "/" + request.bransId,
                method: "GET",
            }),
        }),
        hastaMuayeneSablonEkle: builder.mutation<HbsHastaMuayeneSablonDTO, HbsHastaMuayeneSablonDTO>({
            query: (request) => ({
                url: "hastaservis/hastaMuayeneSablonEkle",
                method: "POST",
                body: JSON.stringify(request)
            })
        }),
        hastaMuayeneSablonGuncelle: builder.mutation<boolean, HbsHastaMuayeneSablonDTO>({
            query: (request) => ({
                url: "hastaservis/hastaMuayeneSablonGuncelle",
                method: "PUT",
                body: JSON.stringify(request)
            })
        }),
        hastaMuayeneSablonSil: builder.mutation<boolean, number>({
            query: (id) => ({
                url: "hastaservis/hastaMuayeneSablonSil/" + id,
                method: "DELETE"
            })
        }),
        getVwHbsHataReceteList: builder.query<Array<VwHbsHastarecetelistDTO>, {
            muracaatId: number,
            hastaServisId: number,
            iptal: string
        }>({
            query: (req) => ({
                url: "hastaservis/GetVwHbsHataReceteList",
                method: "GET",
                params: {
                    muracaatId: req.muracaatId,
                    hastaServisId: req.hastaServisId,
                    iptal: req.iptal
                }
            }),
        }),
        VwHbHastaRecete1Create: builder.mutation<VwHbsHastarecete1DTO, VwHbsHastarecete1DTO>({
            query: (request) => ({
                url: "VwHbsHastarecete1DTO",
                method: "POST",
                body: JSON.stringify(request)
            })
        }),
        VwHbHastaRecete1Update: builder.mutation<boolean, VwHbsHastarecete1DTO>({
            query: (request) => ({
                url: "VwHbsHastarecete1DTO",
                method: "PUT",
                body: JSON.stringify(request)
            })
        }),
        VwHbHastaRecete2Create: builder.mutation<VwHbsHastarecete2DTO, VwHbsHastarecete2DTO>({
            query: (request) => ({
                url: "VwHbsHastarecete2DTO",
                method: "POST",
                body: JSON.stringify(request)
            })
        }),
        VwHbHastaRecete2Update: builder.mutation<boolean, VwHbsHastarecete2DTO>({
            query: (request) => ({
                url: "VwHbsHastarecete2DTO",
                method: "PUT",
                body: JSON.stringify(request)
            })
        }),
        getVwHbsHataRecete2List: builder.query<Array<VwHbsHastarecete2DTO>, number>({
            query: (request) => {
                var apiRequest: ApiRequest<VwHbsHastarecete2DTO> = {
                    filters: {
                        groupOperator: "and",
                        predicates: [
                            {
                                fieldName: "receteId",
                                operator: "=",
                                value1: request,
                            },
                            {
                                fieldName: "iptal",
                                operator: "=",
                                value1: "H",
                            }
                        ]
                    },
                    sorts: [
                        { fieldName: "id", ascending: false }
                    ],
                    paging: false
                }

                return {
                    url: "VwHbsHastarecete2DTO/find",
                    method: "POST",
                    body: apiRequest
                }
            }
        }),
        getVwHbsHbsHastaRecete1BydId: builder.query<VwHbsHastarecete1DTO, number>({
            query: (request) => ({
                url: "VwHbsHastarecete1DTO/" + request,
                method: "GET",
            })
        }),
        getHastaMuayeneKimlik: builder.query<Array<HbsHastaMuayeneDTO>, {
            kimlikId: number,
            raporId: number
        }>({
            query: (request) => {
                let apiRequest: ApiRequest<HbsHastaMuayeneDTO> = {
                    filters: {
                        groupOperator: "and",
                        predicates: [
                            { fieldName: "kimlikId", operator: "=", value1: request.kimlikId },
                            { fieldName: "raporId", operator: "=", value1: request.raporId },
                        ]
                    },
                    sorts: [
                        { fieldName: "tarih", ascending: false }
                    ]
                }
                return {
                    url: controllerName + "/find",
                    method: "POST",
                    body: JSON.stringify(apiRequest)
                }
            },
            providesTags: ["HastaMuayeneKimlik"]
        })
    }),
})

export const {
    useGetHastaMuayeneQuery,
    useAddHastaMuayeneMutation,
    useUpdateHastaMuayeneMutation,
    useDeleteHastaMuayeneMutation,
    useHastaMuayeneSablonGetirQuery,
    useHastaMuayeneSablonEkleMutation,
    useHastaMuayeneSablonGuncelleMutation,
    useHastaMuayeneSablonSilMutation,
    useGetVwHbsHataReceteListQuery,
    useGetVwHbsHataRecete2ListQuery,
    useVwHbHastaRecete1CreateMutation,
    useVwHbHastaRecete1UpdateMutation,
    useVwHbHastaRecete2CreateMutation,
    useVwHbHastaRecete2UpdateMutation,
    useLazyGetVwHbsHbsHastaRecete1BydIdQuery,
    useGetHastaMuayeneKimlikQuery
} = HastaMuayeneApi;